export default __webpack_public_path__ + "static/media/logo.a5a56e06.png";